import {
  WheelSetSpecificationCoverage,
  WheelSetSpecificationCoverageLabels,
  type CarListApiData,
  type UserGroupFleetViewCarsListApiData
} from '@navio/nsdk';
import { filterUnitFor, type SharedQuery } from 'noddi-ui-web';
import { getLabelMapFromEntries } from 'noddi-util';

type CarQuery = NonNullable<CarListApiData['query']>;
type FleetQuery = NonNullable<UserGroupFleetViewCarsListApiData['query']>;
const unit = filterUnitFor<SharedQuery<CarQuery, FleetQuery>>();
const labels = getLabelMapFromEntries(WheelSetSpecificationCoverage, WheelSetSpecificationCoverageLabels);
const options = [
  WheelSetSpecificationCoverage.ALL,
  WheelSetSpecificationCoverage.SOME,
  WheelSetSpecificationCoverage.NONE,
  WheelSetSpecificationCoverage.NO_SETS
].map((value) => ({ value, label: labels[value] }));

export const wheelSetCoverageFilters = [
  unit.multiSelect('tirePressureCoverage', {
    title: 'Reviewed tire pressure',
    description:
      'Coverage of registered wheel sets by mapped catalog packages. Every axle must have a pressure value. Empty seasonal placeholders are excluded.',
    options,
    exclude: true
  }),
  unit.multiSelect('wheelTorqueCoverage', {
    title: 'Reviewed wheel nut torque',
    description:
      'Coverage of registered wheel sets by mapped catalog packages with torque data. Empty seasonal placeholders are excluded.',
    options,
    exclude: true
  })
];
